"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultVideoCaptureAndEncodeParameter_1 = __importDefault(require("../videocaptureandencodeparameter/DefaultVideoCaptureAndEncodeParameter"));
class NoVideoUplinkBandwidthPolicy {
    constructor() { }
    updateConnectionMetric(_metrics) { }
    chooseMediaTrackConstraints() {
        return {};
    }
    chooseEncodingParameters() {
        return new Map();
    }
    updateIndex(_videoIndex) { }
    wantsResubscribe() {
        return false;
    }
    chooseCaptureAndEncodeParameters() {
        return new DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, false);
    }
    maxBandwidthKbps() {
        return 0;
    }
    setIdealMaxBandwidthKbps(_idealMaxBandwidthKbps) { }
    setHasBandwidthPriority(_hasBandwidthPriority) { }
}
exports.default = NoVideoUplinkBandwidthPolicy;
//# sourceMappingURL=NoVideoUplinkBandwidthPolicy.js.map